module.exports = __webpack_public_path__ + "./images/6259a67d36a494eccba6b8e22198a05a.png";